import React from "react";
// import Button from "../Button";
import { StyledDiv } from "./Section8.style";
import Vector from "../../assets/images/Group.png";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import '../../assets/css/section.css'
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
const LeftImageContainer = styled.div`
  position: absolute;
  bottom: -160px;
`;
interface Section8Props {
  handleMenuItemClick: (menuItemKey?: any) => void;
}
const RightImageContainer = styled.div`
  position: absolute;
  top: 9px;
  right: 0;
`;
 
const Section8: React.FC<Section8Props> = ({ handleMenuItemClick }) => {
  const history = useHistory();
  const handleopenHelpCenter=(menuItem:any)=>{
    history.push('/myindici-for-providers')
    window.scrollTo(0, 0);
    handleMenuItemClick(menuItem)
  }
  return (
    <StyledDiv className="indichelpcenterdiv">
      <RightImageContainer>
        <img src={Vector} alt="" style={{}} />
      </RightImageContainer>
      <div className="container text-center indichelpcenter modrenHealth">
        <div className="row">
          <div className="col-md-12 ">
            <h2 className="myindici-heading2 mb-4">myindici Help Centre</h2>
            <p className="benefitsmyindici">
              Everybody needs help sometimes! Here at myindici, we are dedicated
              to providing you with all the help we can. Check out our<br/> range of
              video tutorials and FAQs, and if you can't find the answer you
              need there, get in touch with us directly.
            </p>
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-md-4 mx-auto">
          <Link className="help-center text-white btn btn-primary"
            to="/help-center" onClick={()=>handleopenHelpCenter('Help Centre')} >Open Help Center</Link>
            {/* <Button className="help-center">Open Help Center</Button> */}
             </div>
        </div>
      </div>
    </StyledDiv>
  );
};
 
export default Section8;
 